import styled from 'styled-components';

export const Pre = styled.pre`
  font-size: 1rem;
  padding: 6px 12px;
  margin: 0;
  border-radius: 4px;
  background-color: var(--bg-2); /* works in both themes */
  color: var(--body-text); /* base text color */
  border: 1px solid var(--bg-4);

  overflow-x: auto;
  line-height: 1.6;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;

  .string {
    color: var(--blue); /* red in your theme */
  }

  .number,
  .boolean,
  .null {
    color: var(--green, #2cbe4e); /* fallback just in case */
  }

  .key {
    color: var(--title-text); /* strong & readable in both themes */
  }

  .punctuation {
    color: var(--bg-4); /* subtle, neutral gray */
  }

  .comment {
    color: var(--text-muted, #9ca5af);
    font-style: italic;
  }
`;
